import { compareHtmlNodes, getSingleUIProps } from './util';

function parseServiceRequestAsAction(service, serviceElement) {
  const action = {
    actionName: service.name,
    internalAction: '',
    externalAction: { linkHref: service.url, method: service.typeRequest },
    customCode: '',
    UIProps: getSingleUIProps(serviceElement)
  };
  return action;
}

// This function parse a single html element and get the text
function parseSimpleText(node) {
  const answer = {};
  answer.entryName = node.getAttribute('value-key');
  answer.entryType = 'string';
  answer.UIProps = [];
  answer.UIProps = getSingleUIProps(node);
  return answer;
}

// This rule return a data model from a list table
function parseServiceElements(serviceElement) {
  //  TODO simplify the split with match or search just needing the projectIndex
  const projectIndex = serviceElement.getAttribute('wabli-service-id').split(/Project|Block/)[1];

  const { services_blocks: servicesBlocks, services_requests: servicesRequests } = JSON.parse(
    localStorage.getItem('data')
  )[projectIndex].services[0];

  const serviceBlockDesc = servicesBlocks.filter(
    (serviceBlock) => serviceBlock.id === serviceElement.getAttribute('wabli-service-id')
  )[0];
  const serviceName = serviceBlockDesc.label.slice(0, serviceBlockDesc.label.indexOf(' '));
  const serviceRequest = servicesRequests.filter(
    (serviceRequestItem) => serviceRequestItem.name === serviceName
  )[0];

  const data = {
    schema: [],
    UIElementd: serviceElement.getAttribute('id'),
    dataName: `${serviceName}${serviceElement.getAttribute('id')}`,
    attributeName: serviceName || 'not named',
    buttons: [],
    actions: [parseServiceRequestAsAction(serviceRequest, serviceElement)]
  };

  let subElement = serviceElement.querySelectorAll('[value-key]');

  subElement = Array.from(subElement).sort(compareHtmlNodes);

  for (const node of subElement) {
    data.schema.push(parseSimpleText(node));
  }

  return data;
}

export { parseServiceElements };
